<script setup lang="ts">
import { useDebounce } from '@vueuse/core'
import { LucideCircleX, LucideSearch } from 'lucide-vue-next'

const props = defineProps<{
  modelValue: string
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const searchQueryString = ref(props.modelValue)
const debouncedQuery = useDebounce(searchQueryString, 500)

watch(
  () => props.modelValue,
  (newVal) => {
    if (newVal !== searchQueryString.value) {
      searchQueryString.value = newVal
    }
  }
)

watch(debouncedQuery, (newValue) => {
  emit('update:modelValue', newValue)
})
</script>

<template>
  <div class="relative">
    <Input
      v-model="searchQueryString"
      type="text"
      :placeholder="$t('widget.faq_page.search_placeholder')"
      class="h-12 w-full rounded-md pl-12"
    />
    <LucideSearch class="pointer-events-none absolute left-4 top-3.5 size-5 text-gray-600" />
    <Button
      v-if="searchQueryString"
      size="icon"
      variant="link"
      class="absolute right-4 top-3 size-6 text-red-400 hover:text-red-400"
      @click="searchQueryString = ''"
    >
      <LucideCircleX />
    </Button>
  </div>
</template>
